import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useDistributor = () => {
  const [distributors, setDistributors] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/distributor/all')
        .then((response) => {
          setDistributors(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [distributors]
}

export default useDistributor
